<template>
  <scroll-page :titleArrs="titleArrs" :pageArrs="pageArrs" />
</template>
<script>
export default {
  name: 'PlanManage',
  data(){
    return{
      pageArrs: ['PlanOne', 'PlanTwo', 'PlanFive', 'PlanThree', 'PlanFour'],
      titleArrs: ['计划管理', '计划管理', '计划管理', '计划管理', '计划管理']
    }
  }
}
</script>